import { ADMIN_AUDIT_LOGS_ENDPOINTS, AdminAuditLogsService } from "@/service/api/admin-audit-logs";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";

const useLogDetails = (id?: string) => {
  const query = useQuery({
    queryKey: [ADMIN_AUDIT_LOGS_ENDPOINTS.GET_UNIQUE_LOG("id"), id],
    queryFn: () => AdminAuditLogsService.getUniqueLog(id as string),
    enabled: !!id,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar detalhes do log.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useLogDetails;
